import AvatarUploader from './avatar_uploader';
import PhoneInput from './phone_input';

export default class CommunityMemberProfile {
  constructor() {
    new AvatarUploader();
    new PhoneInput();
  }
}
